<ng-container *apSecure='[Permissions.ACCESS_ALL_SUBSCRIPTIONS]'>
  @if (statusHistoryDataSource?.data?.length > 0) {
    <ap-panel>
      <ap-panel-title>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.TITLE'| translate }}</ap-panel-title>
      <ap-panel-content>
        <div class='row table-responsive'>
          <table #table [dataSource]='statusHistoryDataSource' aria-describedby='datatable_info' class='table table-hover table-bordered table-fixed no-footer' id='datatable' mat-table role='grid'>
            <ng-container matColumnDef='{{ displayedColumns[0] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[0] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>{{ 'STATUS.SUBSCRIPTION.STATUSES_HISTORY.STATUS.' + subscriptionStatusHistory?.status | translateIfExist: subscriptionStatusHistory?.status | noData }}</td>
            </ng-container>
            <ng-container matColumnDef='{{ displayedColumns[1] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[1] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>{{ subscriptionStatusHistory?.effectiveDate | date: "dd/MM/yy 'à' HH'h'mm" | noData }}</td>
            </ng-container>
            <ng-container matColumnDef='{{ displayedColumns[2] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[2] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>
                @if (!subscriptionStatusHistory.statusReasons || subscriptionStatusHistory.statusReasons.length === 0) {
                  -
                }
                @for (motif of subscriptionStatusHistory.statusReasons; track motif) {
                  {{ motif }}<br>
                }
              </td>
            </ng-container>
            <ng-container matColumnDef='{{ displayedColumns[3] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[3] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>{{ 'STATUS.SUBSCRIPTION.STATUSES_HISTORY.STATE.' + subscriptionStatusHistory?.state | translateIfExist: subscriptionStatusHistory?.state | noData }}</td>
            </ng-container>
            <ng-container matColumnDef='{{ displayedColumns[4] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[4] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>{{ subscriptionStatusHistory?.errorReason | noData }}</td>
            </ng-container>
            <ng-container matColumnDef='{{ displayedColumns[5] }}'>
              <th *matHeaderCellDef mat-header-cell>{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.COLUMNS.' + displayedColumns[5] | translate }}</th>
              <td *matCellDef='let subscriptionStatusHistory' mat-cell>
                @if (canShowTrashIcon(subscriptionStatusHistory)) {
                  <button (click)='deleteSubscriptionStatusHistory(subscriptionStatusHistory)' class='btn btn-sm btn-danger' type='button' ap-tooltip="{{ 'SUBSCRIPTIONS.SUBSCRIPTION_DETAILS.STATUS_HISTORY.LIST.BUTTONS.DELETE_STATUS_HISTORY' | translate }}" placement='top'><i class='fa fa-trash'></i></button>
                }
              </td>
            </ng-container>
            <tr *matHeaderRowDef='displayedColumns' mat-header-row></tr>
            <tr *matRowDef='let row; columns: displayedColumns;' class='odd' mat-row role='row'></tr>
          </table>
        </div>
      </ap-panel-content>
    </ap-panel>
  }
</ng-container>
